import { Directive, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Converts same-host anchor clicks to Angular Router navigation.
 *
 * - Ignores links with `target="_blank"` or external hosts (except localhost in dev).
 * Prevents the browser’s default navigation behavior and uses router.navigateByUrl()
 * to avoid a full application reload when the link points to a route within the current app.
 *
 * Example:
 * ```html
 * <div hrefProcessor>
 *   <a href="/docs/intro">Docs intro</a>
 * </div>
 * ```
 */
@Directive({
    selector: '[hrefProcessor]',
    standalone: true,
})
export class HrefProcessorDirective {
    protected router = inject(Router);

    @HostListener('click', ['$event'])
    /**
     * Intercepts clicks on anchors and routes internally for same-host links.
     */
    public onClick(e) {
        if (!e.target.href) return;
        if (e.target.target === '_blank') return;
        if (e.target.host !== location.host && location.host.indexOf('localhost') === -1) return;

        e.preventDefault();
        this.router.navigateByUrl(e.target.pathname);
    }
}
